import { Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useAuthContext } from 'context/AuthContext'
import { useGlobalState } from 'context/GlobalStateContext'
import { CIMSModule, Permission } from 'shared'

const Home: React.FC = () => {
  const {
    state: { projectGlobalId },
    dispatch: { updateNavKey },
  } = useGlobalState()
  const { user } = useAuthContext()
  const [project, setProject] = useState<string>()
  useEffect(() => {
    if (projectGlobalId && user)
      setProject(user.projects?.find(({ id }) => id === projectGlobalId)?.name)
    else setProject(undefined)
  }, [projectGlobalId, user])

  /**
   * we might be redirected here from ProtectedRoute
   *
   * in those situations, the navKey isn't actually updated because you can't
   * update state during a render function
   *
   * we'll just manually set the navKey if we make it in here
   */
  updateNavKey(CIMSModule.Home.id)

  return (
    <Space direction="vertical">
      {project ? (
        <>
          <Typography.Paragraph strong>
            Welcome to {project}
            {!!user && <>, {user.username}</>}
          </Typography.Paragraph>
          {user?.someAuthorized(Permission.basics, projectGlobalId)
            .authorized ? (
            <Typography.Paragraph>
              Open the side menu and select a module to get started
            </Typography.Paragraph>
          ) : (
            <>
              <Typography.Paragraph>
                You do not have permission to access any modules
              </Typography.Paragraph>
              <Typography.Paragraph>
                Please reach out to your Horrocks contact point. They will need
                to give you a role or specific permissions to access any modules
              </Typography.Paragraph>
              <Typography.Paragraph>
                When permission has been granted, you may need to reload the
                page
              </Typography.Paragraph>
            </>
          )}
        </>
      ) : (
        <Typography.Paragraph strong>
          Select a project above to get started
        </Typography.Paragraph>
      )}
    </Space>
  )
}

export default Home
